import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useSiteSettings from "../lib/useSiteSettings";
import { applyContentOverrides } from "../lib/contentOverrides";

// Legacy editorial images and labels share the same draft/publish settings as the CMS.
export default function ContentOverrides() {
  const settings = useSiteSettings();
  const { pathname } = useLocation();
  useEffect(() => applyContentOverrides(document.querySelector('.App'), settings, pathname), [settings, pathname]);
  return null;
}
